import React, { useState, useEffect } from 'react';
import './QuickStatsSettings.css';

function QuickStatsSettings({ onClose, currentPrefs, onSave }) {
  const [selectedStats, setSelectedStats] = useState([]);
  const [saving, setSaving] = useState(false);

  // All available stats
  const availableStats = [
    { key: 'total_contacts', label: 'Total Contacts' },
    { key: 'added_this_week', label: 'Added This Week' },
    { key: 'tasks_completed_today', label: 'Tasks Completed Today' },
    { key: 'pending_tasks', label: 'Pending Tasks' },
    { key: 'total_conversations_started', label: 'Total Conversations Started' },
    { key: 'total_presentations_finished', label: 'Total Finished Presentations' },
    { key: 'total_followups', label: 'Total Follow-ups' },
    { key: 'total_closings', label: 'Total Closings' },
    { key: 'total_customers', label: 'Total Customers' },
    { key: 'total_marketers', label: 'Total Marketers' }
  ];

  useEffect(() => {
    // Load current preferences or default
    if (currentPrefs && currentPrefs.length > 0) {
      setSelectedStats(currentPrefs);
    } else {
      setSelectedStats(['total_contacts', 'added_this_week', 'tasks_completed_today', 'pending_tasks']);
    }
  }, [currentPrefs]);

  const toggleStat = (key) => {
    if (selectedStats.includes(key)) {
      setSelectedStats(selectedStats.filter(k => k !== key));
    } else {
      if (selectedStats.length < 5) {
        setSelectedStats([...selectedStats, key]);
      }
    }
  };

  const moveUp = (index) => {
    if (index > 0) {
      const newSelected = [...selectedStats];
      [newSelected[index - 1], newSelected[index]] = [newSelected[index], newSelected[index - 1]];
      setSelectedStats(newSelected);
    }
  };

  const moveDown = (index) => {
    if (index < selectedStats.length - 1) {
      const newSelected = [...selectedStats];
      [newSelected[index], newSelected[index + 1]] = [newSelected[index + 1], newSelected[index]];
      setSelectedStats(newSelected);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await fetch('/backend/api/dashboard/save-quick-stats-prefs.php', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ stats: selectedStats })
      });

      if (response.ok) {
        onSave(selectedStats);
        // Refresh page to reload user data and stats with new preferences
        window.location.reload();
      } else {
        alert('Failed to save preferences');
        setSaving(false);
      }
    } catch (error) {
      console.error('Error saving preferences:', error);
      alert('Failed to save preferences');
      setSaving(false);
    }
  };

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-popup" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h2>Customize Quick Stats</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <p className="settings-subtitle">
          Select up to 5 stats and reorder them
        </p>

        <div className="settings-content">
          {availableStats.map((stat) => {
            const isSelected = selectedStats.includes(stat.key);
            const selectedIndex = selectedStats.indexOf(stat.key);
            
            return (
              <div key={stat.key} className={`stat-row ${isSelected ? 'selected' : ''}`}>
                <div className="stat-left">
                  <span className="stat-label">{stat.label}</span>
                  {isSelected && (
                    <div className="order-controls">
                      <button 
                        onClick={() => moveUp(selectedIndex)}
                        disabled={selectedIndex === 0}
                        className="order-btn"
                      >
                        ↑
                      </button>
                      <span className="order-number">{selectedIndex + 1}</span>
                      <button 
                        onClick={() => moveDown(selectedIndex)}
                        disabled={selectedIndex === selectedStats.length - 1}
                        className="order-btn"
                      >
                        ↓
                      </button>
                    </div>
                  )}
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleStat(stat.key)}
                    disabled={!isSelected && selectedStats.length >= 5}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            );
          })}
        </div>

        <div className="settings-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="save-button" onClick={handleSave} disabled={saving || selectedStats.length === 0}>
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuickStatsSettings;

